package com.example.mystybag.login.views.views

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.login.logic.MerchantRegistrationAddLoginDetailsViewModel
import com.example.mystybag.login.views.MerchantRegistrationAddLoginDetailsForm
import com.example.mystybag.login.views.components.MerchantRegistrationWebBoundedColumn

@Composable
fun MerchantRegistrationAddLoginDetailsWebView(
    viewModel: MerchantRegistrationAddLoginDetailsViewModel
) {
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        horizontalAlignment = Alignment.Start
    ) { _ ->
        MerchantRegistrationWebBoundedColumn(Modifier.fillMaxSize()) {
            MerchantRegistrationAddLoginDetailsForm(viewModel)
        }
    }
}
